// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3mkTM","name":"ConsentHeader_name__3BsNq","birthday":"ConsentHeader_birthday__3eBa7","skeleton":"ConsentHeader_skeleton__MaDhy"};